import { Label as UIKitLabel } from '@cian/ui-kit';

import {
  IconProductHighDemand16,
  IconProductCianLogo12,
  IconProductDocumentsVerified12,
} from '@cian/ui-kit-design-tokens/icons';

import * as React from 'react';

import { getTextColor } from './utils';
import { EColor, IPhotoLabel } from '../../types';
import { SuperAgentIcon } from '../SuperAgentIcon';

//TODO: Заменить на цвет из кита, когда цвет будет поддерживаться в ките.
const ACCENT_SUCCESS_10 = 'rgba(58, 197, 0, 0.10)';

const BACKGROUND_MAP: Partial<Record<EColor, string>> = {
  orange: 'surface-warning-default',
  blue: 'accent-main-secondary',
  blueOnlyCian: 'accent-main-secondary',
  blueGoodPrice: 'accent-main-secondary',
  green: ACCENT_SUCCESS_10,
  greenForOwner: ACCENT_SUCCESS_10,
  greenForCheckedOwner: ACCENT_SUCCESS_10,
  white: 'gray10_100',
  grey: 'transparent',
  purpleDiscountMortgage: 'var(--decorative-lavender)',
  greenForSuperAgent: ACCENT_SUCCESS_10,
};

const ICON_MAP: Partial<Record<EColor, React.ReactElement<any>>> = {
  blueOnlyCian: <IconProductCianLogo12 color="icon-main-default" />,
  greenForCheckedOwner: <IconProductDocumentsVerified12 color="icon-positive-default" />,
  purpleDiscountMortgage: <IconProductHighDemand16 color="decorative-purple" />,
  greenForSuperAgent: <SuperAgentIcon />,
};

export const LabelComponent: React.FC<IPhotoLabel> = ({ color, name }) => {
  return (
    <UIKitLabel background={BACKGROUND_MAP[color]} color={getTextColor(color)} icon={ICON_MAP[color]}>
      {name}
    </UIKitLabel>
  );
};

export const Label = React.memo(LabelComponent);
